import { render } from "./ButtonBox.vue?vue&type=template&id=33856d4e&scoped=true"
import script from "./ButtonBox.vue?vue&type=script&lang=js"
export * from "./ButtonBox.vue?vue&type=script&lang=js"

import "./ButtonBox.vue?vue&type=style&index=0&id=33856d4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33856d4e"]])

export default __exports__